import React, { useEffect } from 'react';
import { Icon, Loader, Message, Divider, Container, Grid, Button, Segment, Card } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import actions from 'actions';
import { api } from 'api';

import RichTextViewer from 'components/includes/RichTextViewer';
import Welcome from './Welcome';

function Participate({ participant, trial, stages, team, t, onReceiveStage, onParticipantLogout, history }) {
  const trialId = trial && trial._id;

  useEffect(() => {
    if (!trialId) return;
    api.participants.getTrialStages(trialId, data => {
      data.stages.forEach(onReceiveStage);
    });
  }, [trialId, onReceiveStage]);

  function logout() {
    api.participants.logout(() => {
      onParticipantLogout();
      history.push('/');
    });
  }

  function completedAllStages() {
    if (trial && participant) {
      return !stages.filter(s => s.enabled && !s.completed).length;
    }
    return true;
  }

  if (!trial) return (<Loader style={{marginTop: 40}} centered='inline' active />);
  if (participant && trial && trial.conditions && (!participant.trialConditionAgreements || !participant.trialConditionAgreements.length)) return <Welcome />;

  return (
    <Container style={{marginTop: 40}} className='participant-view'>
      <Grid stackable centered>
        <Grid.Column computer={6} tablet={6}>
          <Card>
            <Card.Content>
              <Card.Header>{trial.name}</Card.Header>
              <Card.Meta>{t('trial.presentedBy', {teamName: team && team.name})}</Card.Meta>
            </Card.Content>
            <Card.Content>
              <RichTextViewer content={trial.description} />
            </Card.Content>
          </Card>
        </Grid.Column>
        <Grid.Column computer={10} tablet={10}>
          {completedAllStages() &&
            <Segment color='teal' style={{marginBottom: 30}}>
              <h2>{t('trial.thanks.title')}</h2>
              <p>{t('trial.thanks.info')}</p>
              <Button size='large' fluid color='teal' content={t('trial.logout')} onClick={logout} />
            </Segment>
          }

          {stages.filter(s => s.adHoc).length > 0 && <>
            <h2>{t('trial.stages.adHoc.title')}</h2>
            <p>{t('trial.stages.adHoc.info')}</p>
            {stages.filter(s => s.adHoc).map(s =>
              <Segment key={s._id}>
                <Grid stackable>
                  <Grid.Column computer={6} verticalAlign='middle'>
                    <h3>{s.name}</h3>
                  </Grid.Column>
                  <Grid.Column computer={10} verticalAlign='middle'>
                    <Link className='ui huge blue fluid button' to={`/participate/${s._id}`}>{t('trial.stages.adHoc.start')}</Link>
                    {s.lastRecordedAt && <p style={{fontSize: 12, color: 'gray', marginTop: 10, textAlign: 'center'}}>{t('trial.stages.adHoc.lastRecorded')}: {moment(s.lastRecordedAt).format('DD MMMM YYYY HH:mm')}</p>}
                  </Grid.Column>
                </Grid>
              </Segment>
            )}
            <Divider section />
          </>}

          <h2>{t('trial.stages.title')}</h2>
          <p>{t('trial.stages.info')}</p>
          {stages.filter(s => !s.adHoc).map(s =>
            <Segment key={s._id}>
              
              <Grid stackable>
                <Grid.Column computer={6} verticalAlign='middle'>
                  <h3>{s.name}</h3>
                </Grid.Column>
                <Grid.Column computer={10} verticalAlign='middle'>
                  {s.completed ?
                    <Message success><Icon name='check' /> {t('trial.stages.completed')}</Message>
                  :
                    (s.enabled ?
                      <Link className='ui huge teal fluid button' to={`/participate/${s._id}`}>{t('trial.stages.start')}</Link>
                    :
                      (s.enableAt ?
                        <Message info>Available {moment(s.enableAt).fromNow()}</Message>
                      :
                        <Message>{t('trial.stages.notAvailable')}</Message>
                      )
                    )
                  }
                </Grid.Column>
              </Grid>
            </Segment>
          )}
        </Grid.Column>
      </Grid>
    </Container>
  );
}

const mapStateToProps = (state) => {
  const { currentParticipantId, isLoadingMe } = state.participants;
  const participant = state.participants.participants.filter(p => p._id === currentParticipantId)[0];
  const trial = state.trials.trials.filter(t => t._id === (participant && participant.trial))[0];
  const stages = state.stages.stages.filter(s => s.trial === (trial && trial._id));
  const team = state.teams.teams.filter(t => t._id === (participant && participant.team))[0];
  return { isLoadingMe, participant, trial, stages, team };
};
const mapDispatchToProps = dispatch => ({
  onReceiveStage: stage => dispatch(actions.stages.receiveStage(stage)),
  onParticipantLogout: () => dispatch(actions.participants.logout()),
});

const ParticipateContainer = withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Participate)));

export default ParticipateContainer;
